module.exports = __webpack_public_path__ + "img/智能识别--手势识别.3445be20.png";